import React, { useState } from 'react';
import { Trans } from '@lingui/react';
import styled from 'styled-components';
import {
    SectionContainer,
    SectionHeading,
    smallScreenBreakpoint1064px,
} from '../../styles/common';
import { Mode } from '~services/business/pricing';
import { Country } from '~services/i18n/country';
import { PricingPlan } from './pricing-plan';
import { memberships } from './memberships';
import { theme } from '../../globalStyles';
import { PricingSwitcher } from './components/pricing-switcher';
import { Currency } from '~services/i18n/currency';

type PricingTableProps = {
    country: Country;
    currency: Currency;
    language: string;
};
export const PricingTable = ({
    country,
    currency,
    language,
}: PricingTableProps) => {
    const [mode, setMode] = useState<Mode>(Mode.MONTHLY);

    const onSelectSide = (): void => {
        if (mode === Mode.MONTHLY) {
            setMode(Mode.YEARLY);
        } else {
            setMode(Mode.MONTHLY);
        }
    };

    return (
        <PaymentAcceptanceSectionContainer id="payment-acceptance">
            <SectionHeading>
                <Trans id="global.pricing.priceTable.heading" />
            </SectionHeading>
            <SectionSubHeading>
                <Trans id="global.pricing.priceTable.subheading" />
            </SectionSubHeading>

            <PricingSwitcher onSelectSide={onSelectSide} mode={mode} />

            <PricingTableWrapper>
                <PricingPlan
                    country={country}
                    currency={currency}
                    language={language}
                    membership={memberships.start}
                    mode={mode}
                />

                <PricingPlan
                    bg={theme.lightPurple}
                    isBulletPlus
                    country={country}
                    currency={currency}
                    hasDivider
                    language={language}
                    membership={memberships.plus}
                    mode={mode}
                    hasSavings
                    isYearly
                />
                {country === Country.CZ && (
                    <PricingPlan
                        isBulletPlus
                        country={country}
                        currency={currency}
                        hasDivider
                        language={language}
                        membership={memberships.premium}
                        mode={mode}
                        hasSavings
                        isYearly
                    />
                )}
            </PricingTableWrapper>
        </PaymentAcceptanceSectionContainer>
    );
};

const SectionSubHeading = styled.div`
    text-align: center;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
`;

const PricingTableWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
    font-family: ${({ theme }) => theme.primaryFont};
    gap: 1rem;
    align-items: stretch;
    @media (max-width: ${smallScreenBreakpoint1064px}) {
        flex-direction: column;
        align-items: center;
        max-width: 500px;
    }
`;

const PaymentAcceptanceSectionContainer = styled(SectionContainer)`
    background-color: white;
`;
